import { EnvironmentNamespace } from '@environment.namespace';

export const environment = new EnvironmentNamespace.Environment();

environment.baseUrl = 'https://sanopass-employer-api-stage.paypoint.md/api';

// учётка у Sanopass
environment.recaptchaSiteKey = '6LfgQJIqAAAAANI-dLuVp-fAtlTXUNqiUvv5sB12';

environment.mockServiceWorker.enabled = false;

environment.mockServiceWorker.endpoints = [
  //'content/getlanguages',
  //'content/gettranslates',
  // 'auth/checklogin',
  //'signin/requestotp',
  //'signin/verifyotp',
  //'signin/resendotp',
  //'recoverpassword/sendotp',
  //'recoverpassword/verifyotp',
  //'recoverpassword/resendotp',
  //'signup/verifytemppassword',
  //'signup/setpassword',
  //'signup/verifyotp',
  //'signup/resendotp',
];
